module.exports = __webpack_public_path__ + "img/pIndex-m-slide3.bc148506.jpg";